import { render, staticRenderFns } from "./MatchRewardIndividualPrizeSection.vue?vue&type=template&id=60a5ede8&scoped=true"
import script from "./MatchRewardIndividualPrizeSection.vue?vue&type=script&lang=js"
export * from "./MatchRewardIndividualPrizeSection.vue?vue&type=script&lang=js"
import style0 from "./MatchRewardIndividualPrizeSection.vue?vue&type=style&index=0&id=60a5ede8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a5ede8",
  null
  
)

export default component.exports